export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_08_blank.a2e42443.png";